export function initPresence(options = {}) {
  const badge = options.badge || document.getElementById('presenceBadge');
  const countEl = badge?.querySelector('[data-presence-count]');
  const endpoint = options.endpoint || 'api.php?action=presence';

  if (!badge || !countEl) {
    return;
  }

  let isRequestInFlight = false;

  function renderCount(count) {
    countEl.textContent = new Intl.NumberFormat('nl-NL').format(count);
    badge.hidden = false;
  }

  async function ping() {
    if (isRequestInFlight || document.visibilityState === 'hidden') {
      return;
    }

    isRequestInFlight = true;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: '{}',
        cache: 'no-store',
        credentials: 'same-origin',
      });

      if (!response.ok) {
        return;
      }

      const payload = await response.json();
      if (!payload?.ok || typeof payload.active_count !== 'number') {
        return;
      }

      renderCount(payload.active_count);
    } catch (_error) {
      // Ignore transient network issues and keep the badge unobtrusive.
    } finally {
      isRequestInFlight = false;
    }
  }

  if (document.visibilityState !== 'hidden') {
    void ping();
  }
}